// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table_JdlPE","actions":"Table_actions_10BOZ"};